import BaseApiClient from '../BaseApiClient';
import { IndustryInterface } from '@interfaces/Industry.interface';

export class ApiIndustry extends BaseApiClient {
  /**
   * Get all items
   */
  async all(industryType?: string): Promise<Array<IndustryInterface>> {
    let url = '/api/v1/get-industries';
    if (industryType) {
      url += `?filter[type]=${industryType}`;
    }

    return new Promise((resolve, reject) => {
      this.client
        .get(url)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { industryQueryKeys } from './query-keys';
export type { IndustryAllQueryParams } from './query-keys';
export { useIndustryAllQuery } from './use-industry-queries';
